import React, { useState, useRef } from 'react';

import { components } from 'common';
const { If } = components;

interface IProps {
    icon?: string;
    children: JSX.Element | string;
    className?: string;
}

import './tipIcon.scss';
export const TipIcon = (props: IProps) => {
    const [showTip, setShowTip] = useState(false);
    const { icon, children, className } = props;
    const tipRef = useRef<HTMLDivElement>(null);

    const show = () => {
        setShowTip(true);
    };
    const hide = () => {
        setShowTip(false);
    };
    const contentStyle = {
        top: tipRef.current ? tipRef.current.getClientRects()[0].top + 15 + 'px' : 0,
        left: tipRef.current ? tipRef.current.getClientRects()[0].left - 30 + 'px' : 0,
    };
    const render = () => {
        const defalutIcon = 'iconfont-pc icon-question-fill';
        return (
            <div
                className={className ? `tip-icon ${className}` : 'tip-icon'}
                onMouseEnter={show}
                onMouseLeave={hide}
                ref={tipRef}
            >
                <i className={icon ? icon : defalutIcon} />
                <If condition={showTip}>
                    <div className="tip-container" style={contentStyle}>
                        {children}
                    </div>
                </If>
            </div>
        );
    };
    return render();
};
